module.exports = __webpack_public_path__ + "img/4da977a.png";